import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { PhotoField } from './PhotoField';

export const Step2 = () => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ width: '100%' }}>
      <Typography variant="subtitle1Bold" gutterBottom>
        {t('stepTitle_confirmBolPhoto')}
      </Typography>
      <PhotoField />
    </Stack>
  );
};
